// extracted by mini-css-extract-plugin
module.exports = {"pasaletras":"Game_pasaletras__2Sr2F","brand":"Game_brand__1TRR_"};